export enum DefaultAssetTypes {
  Color = 'Color',
  ExternalMedium = 'ExternalMedium',
  Font = 'Font',
  GenericFile = 'GenericFile',
  People = 'Person',
  Press = 'Press',
  Text = 'Text'
}
